import Vue from 'vue'
import axios from 'axios'
import { baseURL } from '../config'
//获取地址
export const getAddress = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 添加修改地址
export const addAddress1 = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 删除地址
export const deleteAddress = data => Vue.prototype.getAxios(baseURL + "/index.php", data)